import React from 'react';
import { LastUpdatedText, LeaderboardType, LeaderboardTypes, Table, Wrapper } from './styles';
import Filters from './Filters';
import { IBlockRegion, IFortniteLeaderboardBlockData, getLastUpdatedDateString } from '../utils';
import { useAdminTranslation } from 'hooks/use-translation';
import LoggedUserPosition from './LoggedUserPosition';
import TableHeader from './TableHeader';
import TableBody from './TableBody';
import useToggle from 'hooks/use-toggle';

type LeaderboardProps = {
  defaultFilters: IFortniteLeaderboardBlockData['defaultFilters'];
  region: IBlockRegion;
};

const Leaderboard: React.FC<LeaderboardProps> = ({ region, defaultFilters }) => {
  const { t } = useAdminTranslation();
  const [isRanked, toggleRanked] = useToggle(defaultFilters.leaderboardType === 'ranked');
  const [previousLeaderboardType, setPreviousLeaderboardType] = React.useState(defaultFilters.leaderboardType);

  if (previousLeaderboardType !== defaultFilters.leaderboardType) {
    setPreviousLeaderboardType(defaultFilters.leaderboardType);

    if ((defaultFilters.leaderboardType === 'ranked' && !isRanked) || (defaultFilters.leaderboardType === 'general' && isRanked)) {
      toggleRanked();
    }
  }

  return (
    <Wrapper region={region}>
      <LeaderboardTypes region={region}>
        <LeaderboardType active={!isRanked} onClick={toggleRanked}>{t('GENERAL')}</LeaderboardType>
        <LeaderboardType active={isRanked} onClick={toggleRanked}>{t('RANKED')}</LeaderboardType>
      </LeaderboardTypes>
      <Filters region={region} isRanked={isRanked} />

      {/* TODO: Only show this when oauth by epic */}
      <LoggedUserPosition isRanked={isRanked} region={region} />

      <Table isRanked={isRanked} region={region}>
        <TableHeader isRanked={isRanked} region={region} />
        <TableBody isRanked={isRanked} region={region} />
      </Table>
      {/* TODO: Update this with integration */}
      <LastUpdatedText region={region}>{t('ADMIN_LABEL_LAST_UPDATED')}: {getLastUpdatedDateString(Date.now())}</LastUpdatedText>
    </Wrapper>
  );
};

export default Leaderboard;
